import React from 'react'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { Checkbox, TextField } from '@carsys/form'
import { Box, Divider, Stack, Typography } from '@mui/material'
import { FormValues } from './Form'

const spacing = 1
const dividerStyle = { marginY: 2 }

export const OrderAcknowledgementSettings: React.FC<{}> = () => {
  const { t } = useTranslation()
  const { values: formValues } = useFormikContext<FormValues>()

  return (
    <Box>
      <Divider variant='middle' sx={dividerStyle} />
      <Stack spacing={spacing} pr={2}>
        <Typography variant='h6'>{t('wholesale.OrderCopyTitle')}</Typography>
        <Checkbox
          name='OrderEmailAcknowledgementWholesalerEnabled'
          label={t('wholesale.OrderEmailAcknowledgementWholesalerEmailAddress')}
          title={t('wholesale.OrderEmailAcknowledgementWholesalerEmailAddress_info_title')}
        />
        <TextField
          name='OrderEmailAcknowledgementWholesalerEmailAddress'
          label={t('wholesale.OrderCopyEmailTarget')}
          title={t('wholesale.OrderCopyEmailTarget_info_title')}
          disabled={!formValues.OrderEmailAcknowledgementWholesalerEnabled}
        />
      </Stack>
    </Box>
  )
}

export default OrderAcknowledgementSettings
